import React, { useState, useEffect, Fragment } from "react";
import { Box, Button, Typography, Grid, MenuItem, Stack } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams, useOutletContext } from "react-router-dom";
import MpgItem from "../../../../../CommonFormComp/MpgItem";
import MpgAutocompleteSingle from "../../../../../CommonFormComp/MpgAutocompleteSingle";
import { editClientAccPDValidation } from "./editClientAccPDValidation";
import CircularProgress from "@mui/material/CircularProgress";
import { useGetSignedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetSignedInUserDetails";
import { clientAccPDViewPath } from "../../../../../routes/routePaths";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import ClientAccPDDataTable from "../clientAccPDTableComp/ClientAccPDDataTable";
import { useCreateClientAccPDMutation } from "../../../../../reactQueries/AppApi/rqHooksForClientAccProgrammeDescriptor";
import { useViewProgrammeDescriptorListMutation } from "../../../../../reactQueries/AppApi/rqHooksForProgrammeDescriptor";
import MpgProgrammeDescriptorDialog from "../../../../../CommonFormComp/MpgProgrammeDescriptorListDialog/MpgProgrammeDescriptorDialog";
import { useGetClientAccountDropdownMutation } from "../../../../../reactQueries/AppApi/rqHooksForClientUsers";
import MpgPsudoInput from "../../../../../CommonFormComp/MpgPsudoInput";
import UploadAndCreateCustomPD from "../../uploadAndCreateCustomPD/UploadAndCreateCustomPD";
import { getAccessTypes } from "../../../../../hooksAndFunctions/functions/getAccessTypes";
import { useGetAccountAndSubAccListOnlyForA4Role } from "../../../../../hooksAndFunctions/customHooks/useGetAccountAndSubAccListOnlyForA4Role";

const EditClientAccPD = ({ clientAccPDById }) => {
  const navigate = useNavigate();
  const { id } = useParams()
  const { userName } = useGetSignedInUserDetails();

  const { loggedInUser } = useGetLoggedInUserDetails();
  const { emailAddress, clientPortalAdminRoleId, isEnterpriseAdmin, id: userId } = loggedInUser;

  const {
    clientPortalAdminType
  } = getAccessTypes()
  const {
    isClientPortalAdmin,
    hasA4Access
  } = clientPortalAdminType



  // console.log("loggedInUser", loggedInUser)

  /** !!!!!!!! form handling  !!!!!!!! */

  const { schema } = editClientAccPDValidation();

  const rhfFormInstance = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      pdList: ""
    }
  });

  const { watch, setValue, trigger } = rhfFormInstance;

  const clientAcc = watch("client_account")
  const selectedClientAccId = clientAcc?.id

  /** !!!!!!!! API calls  !!!!!!!! */

  // api - create report resource mutation
  const {
    mutate: updateClientAccProgrammeDescriptor,
    isError: isErrorOnCreate,
    isLoading: isLoadingOnCreate,
    isSuccess: isSuccessOnCreate,
    data: dataOnCreate,
    error: errorOnCreate,
  } = useCreateClientAccPDMutation();


  //api - get client accounts list
  const { mutate: getClientAccountList,
    data: clientAccountList,
    isError: isErrorOnClientAccList,
    isSuccess: isSuccessOnClientAccList,
    error: errorOnClientAccList,
    isLoading: isLoadingOnClientUserData
  } = useGetClientAccountDropdownMutation()

  useEffect(() => {
    getClientAccountList({ loggedInUserId: userId, roleId: clientPortalAdminRoleId, isEnterpriseAdmin })
  }, [loggedInUser])

  const roleBasedClientAccountListData = clientAccountList?.data

  const { mutate: getPDList, isSuccess, error, data: PDData, isError, isLoading: isLoadingOnPDData, } = useViewProgrammeDescriptorListMutation();

  useEffect(() => {
    getPDList({ loggedInUserId: userId, roleId: clientPortalAdminRoleId, isEnterpriseAdmin })
  }, [loggedInUser])

  let filteredPDListForStandardType = !!PDData?.data && PDData?.data.filter((eachItem) => eachItem?.ProgramDescripitorType === "Standard")

  /**
   * client account drop down for A4 role
   */
  const { clientAccListForA4Role } = useGetAccountAndSubAccListOnlyForA4Role({ userId })
  const clientAccAutocompleteListForA4Role = !!clientAccListForA4Role && clientAccListForA4Role
    .map((item) => {
      return {
        id: item.Id,
        selectOptionLabel: `${item.AccountName}`,
        selectOptionValue: item.Id,
        extraData: item,
      };
    });
  /**list of inactive client acc */
  let listOfInactiveClientAccIdsForA4Roleonly = []
  !!clientAccListForA4Role && clientAccListForA4Role.forEach((item) => {
    if (!item.IsActive) {
      listOfInactiveClientAccIdsForA4Roleonly.push(item.Id)
    }
  })

  /**
* client account drop down for rest of roles
*/
  const roleBasedClientAccountAutocomleteListData = !!roleBasedClientAccountListData && roleBasedClientAccountListData
    .map((item) => {
      return {
        id: item.Id,
        selectOptionLabel: `${item.ClientAccountName}`,
        selectOptionValue: item.Id,
        extraData: item,
      };
    });
  /**list of inactive client acc */
  let listOfInactiveClientAccIdsForRestOfRoles = []
  !!roleBasedClientAccountListData && roleBasedClientAccountListData.forEach((item) => {
    if (!item.IsActive) {
      listOfInactiveClientAccIdsForRestOfRoles.push(item.Id)
    }
  })

  // client account auto complete list
  const clientAccountAutocompleteList =
    !!roleBasedClientAccountListData &&
    roleBasedClientAccountListData
      /**for create only passing only active accounts */
      .filter((item) => !!item.IsActive)
      .map((item) => {
        return {
          id: item.Id,
          selectOptionLabel: `${item.ClientAccountName}`,
          selectOptionValue: item.Id,
          extraData: item,
        };
      });

  /** !!!!! handling PD dialog !!!!!!!! */
  const [openPDDialog, setOpenPDDialog] = useState(false);

  /**PD data added into table */
  const [addedPDData, setAddedPDData] = useState([])

  /**handling pdList data for table validation */
  useEffect(() => {
    if (!!addedPDData && !!addedPDData.length) {
      let idForFirstElement = addedPDData[0]?.Id
      setValue("pdList", idForFirstElement);
    } else {
      setValue("pdList", "");
    }
  }, [addedPDData])


  /** populate fields with existing values for edit*/
  /**client acc */
  useEffect(() => {
    if (!hasA4Access) {
      if (!!roleBasedClientAccountListData && !!roleBasedClientAccountListData.length) {
        const foundItem = roleBasedClientAccountListData.find((item) => {
          return item.Id === clientAccPDById.ClientAccountId
        });

        if (!!foundItem) {
          const selectedValue = {
            id: foundItem.Id,
            selectOptionLabel: `${foundItem.ClientAccountName}`,
            selectOptionValue: foundItem.Id,
            extraData: foundItem
          };
          setValue("client_account", selectedValue || "", {
            shouldValidate: true,
          });
        }
      }
    }
  }, [hasA4Access, roleBasedClientAccountListData, clientAccPDById]);

  useEffect(() => {
    if (!!hasA4Access) {
      if (!!clientAccListForA4Role && !!clientAccListForA4Role.length) {
        const foundItem = clientAccListForA4Role.find((item) => {
          return item.Id === clientAccPDById.ClientAccountId
        });

        if (!!foundItem) {
          const selectedValue = {
            id: foundItem.Id,
            selectOptionLabel: `${foundItem.AccountName}`,
            selectOptionValue: foundItem.Id,
            extraData: foundItem
          };
          setValue("client_account", selectedValue || "", {
            shouldValidate: true,
          });
        }
      }
    }
  }, [hasA4Access, clientAccListForA4Role, clientAccPDById]);

  /**PD list */
  useEffect(() => {
    if (!!clientAccPDById?.ProgramDescriptors && clientAccPDById?.ProgramDescriptors?.length) {
      const existingPDList = clientAccPDById?.ProgramDescriptors || []
      const abc = !!existingPDList && existingPDList.map((item) => {
        return {
          ...item,
          /** this Id should be  ProgramDescripitorId to match with selection Id in dialog*/
          Id: item?.ProgramDescripitorId || "",
          clientAccPDTitle: item?.ClientAccountProgramDescripitorTitle || "",
        }
      })
      const pdList1stItem = existingPDList[0]

      setAddedPDData(abc)
      setValue("pdList", pdList1stItem?.ProgramDescripitorId);
    } else {
      setValue("pdList", "");
    }

  }, [clientAccPDById?.ProgramDescriptors])

  /** !!!!!!!! handling submit function  !!!!!!!! */

  const onSubmit = (data) => {
    let programmeDescriptorsList = [];
    if (!!addedPDData && !!addedPDData.length) {
      addedPDData.forEach((item) => {
        programmeDescriptorsList.push({
          ProgramDescripitorId: item?.Id,
          ClientAccountProgramDescripitorTitle: item?.clientAccPDTitle,
          ProgramDescripitorTitle: item?.ProgramDescripitorTitle,
          ProgramDescripitorType: item?.ProgramDescripitorType,
          TobeDeleted: !!item?.TobeDeleted ? true : false
        });
      });
    }

    const body = {
      Id: id,
      ClientAccountId: data?.client_account?.id || "",
      ProgramDescriptors: programmeDescriptorsList || [],
      UpdatedBy: emailAddress || ""
    };

    updateClientAccProgrammeDescriptor({ body });

  };

  useEffect(() => {
    if (!!isSuccessOnCreate) {
      navigate(clientAccPDViewPath);
    }
  }, [isSuccessOnCreate]);

  /**disable update button */
  const [disableUpdateButton, setDisableUpdateButton] = useState(false)
  useEffect(() => {
    if (!!hasA4Access) {
      if (listOfInactiveClientAccIdsForA4Roleonly.includes(clientAccPDById?.ClientAccountId)) {
        setDisableUpdateButton(true)
      } else {
        setDisableUpdateButton(false)
      }
    } else {
      if (listOfInactiveClientAccIdsForRestOfRoles.includes(clientAccPDById?.ClientAccountId)) {
        setDisableUpdateButton(true)
      } else {
        setDisableUpdateButton(false)
      }
    }
  }, [hasA4Access, listOfInactiveClientAccIdsForA4Roleonly, listOfInactiveClientAccIdsForRestOfRoles]);

  const resourcesCMSData = useOutletContext();
  
  const fetchClientAccResListLabel = (key) => {
    //console.log(resourcesCMSDataLabel);
    if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesList"]) {
        const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesList"];
        return returnLabel(resourcesCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const fetchClientAccResDtlsLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
      const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
      return returnLabel(resourcesCMSDataLabel?.Labels, key)
    }
  }

  const fetchCommonCMSLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
        const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
        return returnLabel(commonCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  /**handling custom resources */
  const [openCustomResource, setOpenCustomResource] = useState(false)

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {/* Update Resource for Client Account */}
        {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.UpdateResource')}
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={clientAccPDViewPath}
        >
          {/* Client Account-Resource */}
          {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ButtonClientAccountResource')}
        </Button>
      </Stack>


      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
      >

        <MpgItem>
          <MpgAutocompleteSingle
            rhfFormInstance={rhfFormInstance}
            name={"client_account"}
            label={fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ClientAccount')} //"Client Account"}
            optionList={!!hasA4Access ? clientAccAutocompleteListForA4Role : roleBasedClientAccountAutocomleteListData}
            disabled
          />

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
              m: "20px"
            }}
          >
            <div>
              <Button
                onClick={() => {
                  setOpenPDDialog(true);
                }}
                disabled={
                  !!isLoadingOnPDData
                }
                sx={{ m: "5px", backgroundColor: '#d6deff' }}
              >
                {!!isLoadingOnPDData ? (
                  <Fragment>
                    <CircularProgress size={15} sx={{ margin: "5px" }} />
                    {fetchCommonCMSLabel('Common.Fetching')} {/* Fetching... */}
                  </Fragment>
                ) : (
                  <Fragment>{fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.SelectStandardResource')}</Fragment>
                )}
              </Button>
            </div>

            <Button
              onClick={() => {
                setOpenCustomResource(true)
              }}
              disabled={
                !selectedClientAccId
              }
              sx={{ m: "5px", backgroundColor: '#d6deff' }}
            >
              {/* Add Custom Resource */}
              {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.AddCustomResource')}
            </Button>
          </Grid>

          <div>
            <MpgPsudoInput
              rhfFormInstance={rhfFormInstance}
              name={"pdList"}
              label={fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.SelectedResourceList')} //"Selected Resource List :"}
            />
            <ClientAccPDDataTable
              tableData={addedPDData}
              setTableData={setAddedPDData}
            />
          </div>
        </MpgItem>


        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-evenly"}
          mt={3}
        >
          <Button
            variant="outlined"
            type="submit"
            size="small"
            disabled={!!disableUpdateButton}
          >
            {/* Update */}
            {fetchCommonCMSLabel('Common.Update')}
          </Button>
        </Stack>
      </Box>

      <MpgProgrammeDescriptorDialog
        open={openPDDialog}
        setOpen={setOpenPDDialog}

        addedPDData={addedPDData || []}
        setAddedPDData={setAddedPDData}

        PDListFromAPI={filteredPDListForStandardType || []}
      />

      {/* dialog to add custom resources */}
      <UploadAndCreateCustomPD
        open={openCustomResource}
        setOpen={setOpenCustomResource}

        addedPDData={addedPDData || []}
        setAddedPDData={setAddedPDData}
      />

      {/** error dialog on create action */}
      <MpgErrorDialog
        open={!!isErrorOnCreate}
      />

      <MpgLoadingDialog
        open={
          !!isLoadingOnCreate
        }
      />
    </Box >
  );
};

export default EditClientAccPD;
